import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox-unchecked",
  "use": "icon-checkbox-unchecked-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-checkbox-unchecked\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 0l-768 0c-70.4 0-128 57.6-128 128l0 768c0 70.4 57.6 128 128 128l768 0c70.4 0 128-57.6 128-128l0-768c0-70.4-57.6-128-128-128zM896 896l-768 0 0-768 768 0 0 768z\" p-id=\"7792\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol